import React from 'react';
import FullscreenTopbar from '../WeddingDetails/FullscreenTopbar';
import { FullBleedContainer, TopLevelContainer, Row, Column } from '@xo-union/tk-component-grid';
import styles from './index.scss';
import { Button } from '@xo-union/tk-component-buttons';
import { Overline, H4, Body1 } from '@xo-union/tk-ui-typography';
import classNames from 'classnames';
import Icon from '@xo-union/tk-component-icons';
import WeddingDetails from '../WeddingDetails';
import { OnboardingContext } from '../OnboardingContext';

const ChooseOnboardingType: React.FC = () => {
  const { onboardingType, onSubmit } = React.useContext(OnboardingContext);

  if (onboardingType) {
    //continue onboarding once a selection is made
    return <WeddingDetails />;
  }
  return (
    <div>
      <FullscreenTopbar />
      <FullBleedContainer>
        <TopLevelContainer>
          <Row>
            <Column xs="12">
              <div className={styles.innerContainer}>
                <div className={styles.aiCard}>
                  <Overline className={styles.cardTitle}>option 1</Overline>
                  <div>
                    <H4 className={styles.cardDescription}>Start with AI Assistant</H4>
                    <Icon name="ai_sparkle" className={styles.cardIcon} />
                    <Body1 className={styles.cardSuperScript}>
                      <sup>beta</sup>
                    </Body1>
                  </div>
                  <Body1 className={styles.cardBody}>
                    Get set up with a website design and layout based on your goals and style.
                  </Body1>
                  <Button
                    className={classNames(styles.cardButton, styles.cardEnd)}
                    onClick={() => onSubmit({ type: 'PROPS_CHANGED', payload: { onboardingType: 'AI' } })}
                  >
                    Create website with AI
                  </Button>
                </div>
                <div className={styles.standardCard}>
                  <Overline className={styles.cardTitle}>option 2</Overline>
                  <H4 className={styles.cardDescription}>Set up without AI</H4>
                  <Body1 className={styles.cardBody}>
                    Pick from hundreds of designs and start adding your info to your website.
                  </Body1>
                  <Button
                    className={styles.cardButton}
                    color="secondary"
                    onClick={() => onSubmit({ type: 'PROPS_CHANGED', payload: { onboardingType: 'STANDARD' } })}
                  >
                    Create website
                  </Button>
                </div>
              </div>
            </Column>
          </Row>
        </TopLevelContainer>
      </FullBleedContainer>
    </div>
  );
};

export default ChooseOnboardingType;
